// extracted by mini-css-extract-plugin
module.exports = {"root":"Action__root___c0TWQ behaviors__button___rI7kR","active":"Action__active___p4nCF","primary":"Action__primary___IQ1r3","danger":"Action__danger___B2YXq"};